import type { GapRunEvidence } from '@momentum/types';

/**
 * A run's citations, one bullet each.
 *
 * Every note keeps its own source id rather than the list collecting them at the
 * end: a reviewer checking one line of the claim needs to know which record that
 * line came from, and a shared footer makes them guess.
 *
 * The badge is not a link (SPEC §4.3.3). The ids are `external_id`s and paths
 * into the SharePoint mirror, neither of which the API serves, so a link would
 * be a dead one.
 *
 * `marker` is the bullet the caller wants — `+` and `—` for the validator's two
 * sides, a dot for a neutral list — and `tone` colours it to match.
 */
export function EvidenceList({
  evidence,
  marker,
  tone,
}: {
  evidence: GapRunEvidence[];
  marker: string;
  tone?: string;
}) {
  return (
    <ul className="gr-evlist" data-tone={tone}>
      {evidence.map((entry, entryIndex) => (
        <li key={`${entryIndex}-${entry.note.slice(0, 32)}`}>
          <b>{marker}</b>
          <div>
            {entry.note}
            {(entry.externalId ?? entry.s3Path) !== undefined && (
              <span className="gr-src">{entry.externalId ?? entry.s3Path}</span>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}
